import type { BackofficeNavItem } from "./backofficeNav.types";
import { MANAGER_ROUTES, ROUTES } from "./routes";

export const MANAGER_NAV_ITEMS: readonly BackofficeNavItem[] = [
  { to: ROUTES.backoffice.manager, label: "Inicio", end: true },
  {
    to: `${ROUTES.backoffice.manager}/${MANAGER_ROUTES.linkhub}/${MANAGER_ROUTES.linkGroups}`,
    label: "Central de links",
    permission: "linkhub:manage",
  },
  {
    to: `${ROUTES.backoffice.manager}/${MANAGER_ROUTES.calendar}/${MANAGER_ROUTES.events}`,
    label: "Calendario",
    permission: "calendar:manage",
  },
];
